var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerstype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0469 5.87598H16.2969C16.4958 5.87598 16.6866 5.95499 16.8272 6.09565C16.9679 6.2363 17.0469 6.42706 17.0469 6.62598V15.626C17.0469 15.8249 16.9679 16.0157 16.8272 16.1563C16.6866 16.297 16.4958 16.376 16.2969 16.376H2.79688C2.59796 16.376 2.4072 16.297 2.26654 16.1563C2.12589 16.0157 2.04688 15.8249 2.04688 15.626V3.62598C2.04688 3.42706 2.12589 3.2363 2.26654 3.09565C2.4072 2.95499 2.59796 2.87598 2.79688 2.87598H14.0469V5.87598ZM3.54688 7.37598V14.876H15.5469V7.37598H3.54688ZM3.54688 4.37598V5.87598H12.5469V4.37598H3.54688ZM11.7969 10.376H14.0469V11.876H11.7969V10.376Z",
    fill: "#3AA64C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerstype);
export default __webpack_public_path__ + "static/media/perstype.66ccbc3c527af875f6288a7ca0b0a429.svg";
export { ForwardRef as ReactComponent };